class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static disableShowBtn(){
    let showAllBtn = document.querySelector('.homepage-filter .show-all-products');
    if(showAllBtn){
      document.querySelectorAll('#FacetsWrapperDesktop input').forEach(inp => {
        inp.addEventListener('change', function(){
          showAllBtn.classList.add('disabled');
        });
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    this.disableShowBtn();
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    let collectionContainer = document.getElementById('product-grid');
    let showAllBtn = document.querySelector('.homepage-filter .show-all-products');
    if (showAllBtn) {
  let showAllBtnTxt = '/collections/all?';
  let baseUrl = showAllBtnTxt + searchParams;

  showAllBtn.classList.add('disabled');
  showAllBtn.setAttribute('disabled', 'true');
  const originalText = showAllBtn.innerHTML;
  const getPageVariantCount = (doc) => {
    let count = 0;
    doc.querySelectorAll('[data-variants-count]').forEach(card => {
      const c = parseInt(card.getAttribute('data-variants-count'));
      if (!isNaN(c)) count += c;
    });
    return count;
  };

  fetch(baseUrl)
    .then((response) => response.text())
    .then(async (responseText) => {
      const parser = new DOMParser();
      const firstPageDoc = parser.parseFromString(responseText, 'text/html');

      // 1. Get count from Page 1
      let totalVariants = getPageVariantCount(firstPageDoc);

      // 2. Check how many pages exist
      const totalPagesInput = firstPageDoc.querySelector('#total-pages');
      const totalPages = totalPagesInput ? parseInt(totalPagesInput.value) : 1;

      // 3. If more pages exist, fetch them all in parallel
      if (totalPages > 1) {
        const promises = [];
        for (let i = 2; i <= totalPages; i++) {
          // Construct URL for subsequent pages, preserving searchParams
          const pageUrl = `${baseUrl}&page=${i}`;
          promises.push(fetch(pageUrl).then(res => res.text()));
        }

        const responses = await Promise.all(promises);
        
        responses.forEach(html => {
          const pageDoc = parser.parseFromString(html, 'text/html');
          totalVariants += getPageVariantCount(pageDoc);
        });
      }

      // 4. Update UI (using elements from the first page)
      const allFilters = firstPageDoc.querySelectorAll('.facets__disclosure.js-filter');
      const allFil = document.querySelectorAll('.homepage-filter .facets__disclosure.js-filter');
      const activeFacets = firstPageDoc.querySelectorAll('.active-facets-desktop facet-remove').length;

      allFil.forEach((element, index) => {
        if (allFilters[index]) {
          element.innerHTML = allFilters[index].outerHTML;
          element.replaceWith(allFilters[index].cloneNode(true));
        }
      });

      showAllBtn.innerHTML = activeFacets > 1 
        ? `Show ${totalVariants} Selected Planters` 
        : `Show all ${totalVariants} Planters`;

    })
    .catch((error) => {
       console.error(error);
       showAllBtn.innerHTML = originalText;
    })
    .finally(() => {
       showAllBtn.classList.remove('disabled');
       showAllBtn.removeAttribute('disabled');
    });

  showAllBtn.setAttribute('href', baseUrl);
}
    const url = searchParams;
    const regexHeight = /filter\.v\.m\.custom\.product_height=(\d+(\.\d+)?)/;
    const regexLength = /filter\.v\.m\.custom\.product_length=(\d+(\.\d+)?)/;
    const matchHeight = url.match(regexHeight);
    const matchLength = url.match(regexLength);

    // if (!matchHeight) {
    //   const nonLinearSliderLength = document.querySelector(".ff-custom-height-length .ff-slider-container.Height .ff-range-slider")
    //   const nonLinearSliderLengthmobile = document.querySelector(".mobile-facets__wrapper .js-filter-length-height .ff-slider-container.Heightmobile .ff-range-slider")
    //   nonLinearSliderHeight.noUiSlider.set([0, 0]);
    //   nonLinearSliderHeightmobile.noUiSlider.set([0, 0]);
    //   nonLinearSliderHeight.parentElement.querySelector('input').value = '';
    //   nonLinearSliderHeightmobile.parentElement.querySelector('input').value = '';
    // }

    // if (!matchLength) {
    //   const nonLinearSliderLength = document.querySelector(".ff-custom-height-length .ff-slider-container.Length .ff-range-slider")
    //   const nonLinearSliderLengthmobile = document.querySelector(".mobile-facets__wrapper .js-filter-length-height .ff-slider-container.Lengthmobile .ff-range-slider")
    //   nonLinearSliderLength.noUiSlider.set([0, 0]);
    //   nonLinearSliderLengthmobile.noUiSlider.set([0, 0]);
    //   nonLinearSliderLength.parentElement.querySelector('input').value = '';
    //   nonLinearSliderLengthmobile.parentElement.querySelector('input').value = '';
    // }
    if(collectionContainer){
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
      
      if (countContainer) {
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        countContainer.classList.add('loading');
      }
      if (countContainerDesktop) {
        countContainerDesktop.classList.add('loading');
      }
  
      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;
        
        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });
  
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FfRangeSlider extends HTMLElement {
  constructor() {
    super();
    let customValueMin = this.querySelector('.custom-filter-value-min');
    let customValueMax = this.querySelector('.custom-filter-value-max');
    let minValue = this.querySelector('.ff-min-value');
    let maxValue = this.querySelector('.ff-max-value');
    let thisEle = this;
    this.querySelector('.ff-range-slider').noUiSlider?.on('update', function (values, handle) {
      console.log('min value', values, handle)
      minValue.innerText = '' + parseFloat(values[0]) + ' cm';
      maxValue.innerText = '' + parseFloat(values[1]) + ' cm';
    });
    this.querySelector('.ff-range-slider').noUiSlider?.on('change', function (values, handle) {
        customValueMin.value = parseFloat(values[0]);
        customValueMax.value = parseFloat(values[1]);
        const searchParams = thisEle.createSearchParams(event.target.closest('form'));
        FacetFiltersForm.renderPage(searchParams, event);
        let newRange = thisEle.updateRanges(this.options.range);
        console.log('newRange', newRange)
        thisEle.querySelector('.ff-range-slider').noUiSlider.updateOptions({
          range: newRange
        });
        // maxValue.innerText = this.querySelectorAll(".noUi-origin")[1].getAttribute('aria-valuenow') + ' cm ';
        let showAllBtn = document.querySelector('.homepage-filter .show-all-products');
        if(showAllBtn)showAllBtn.classList.add('disabled');
    });
    if (thisEle.querySelector('.ff-range-slider').noUiSlider) {
      let newRange = thisEle.updateRanges(thisEle.querySelector('.ff-range-slider').noUiSlider.options.range);
      thisEle.querySelector('.ff-range-slider').noUiSlider.updateOptions({
        range: newRange
      });
      minValue.innerText = ' ' + newRange.min + ' cm';
      maxValue.innerText = newRange.max + ' cm ';
    }
    this.querySelector('.ff-min-value').classList.add('active');
  }
  
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  updateRanges(originalRange){
    const sortedArray = Object.entries(originalRange)
      .map(([key, arr]) => ({ key, value: arr[0] }))
      .sort((a, b) => a.value - b.value);
    
    function buildAscendingRange(arr) {
      const newRange = {};
      const length = arr.length;
      arr.forEach((item, index) => {
        if (index === 0) {
          newRange.min = [item.value];
        } else if (index === length - 1) {
          newRange.max = [item.value];
        } else {
          const percent = Math.round((100 / (length - 1)) * index);
          newRange[`${percent}%`] = [item.value];
        }
      });
      return newRange;
    }
    return buildAscendingRange(sortedArray);
  }
}
customElements.define('ff-range-slider', FfRangeSlider);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
